import axios from 'axios'

// 配置基准地址，用于其他地方不是通过axios发请求的地方用上基准地址
export const baseURL = ''

// 配置axios
const instance = axios.create({
  baseURL,
  timeout: 10000
})

// 请求拦截器
instance.interceptors.request.use(config => {
  return config
}, err => {
  return Promise.reject(err)
})

// 响应拦截器
instance.interceptors.response.use(res => res.data, err => {
  return Promise.reject(err)
})

// 请求工具函数
export default (url, method, data) => {
  return instance({
    url,
    method,
    [method.toLowerCase() === 'get' ? 'params' : 'data']: data
  })
}
